import React from "react";
import useWindowSize from "src/utils/useWindowSize";
import styled from "styled-components";

const Footer = () => {
  const isWeb = useWindowSize();

  return (
    <FooterContainer>
      <FooterInner>
        <FooterTop>
          {isWeb ? (
            <>
              <Company>
                <CompanyName>(주) 보이스루</CompanyName>
                <GrayText>
                  서울특별시 강남구 강남대로 374, 10층(역삼동, 케이스퀘어 강남2)
                </GrayText>
                <GrayText>
                  대표자명: 이상헌 | 사업자 등록번호: 342‑88‑01221
                </GrayText>
                <GrayText>고객센터: 02‑6203‑4800</GrayText>
                <Spacer height={10} />
                <a href="https://voithru.com/?mode=policy">
                  <WhiteSmallText>
                    Copyright ⓒ 2025 보이스루 All rights reserved.
                  </WhiteSmallText>
                </a>
              </Company>
              <ServiceContainer>
                <Title>Service</Title>
                <ServiceLinks>
                  <a href="https://voithru.com/translation_localization?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>번역・현지화</WhiteBigText>
                  </a>
                  <a href="https://voithru.com/technology?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>기술</WhiteBigText>
                  </a>
                  <a href="https://voithru.com/content_distribution?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>유통</WhiteBigText>
                  </a>
                </ServiceLinks>
              </ServiceContainer>
              <FamilySites>
                <Title>Family Sites</Title>
                <ServiceLinks>
                  <a href="https://jamake.io/?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>Jamake</WhiteBigText>
                  </a>
                  <a href="https://totus.pro/?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>totus</WhiteBigText>
                  </a>
                  <a href="https://polita.ai/?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>Polita</WhiteBigText>
                  </a>
                </ServiceLinks>
              </FamilySites>
              <ContactContainer>
                <Title>Contact</Title>
                <ContactInfo>
                  <WhiteSmallText>문의 가능 시간 : 10시~19시</WhiteSmallText>
                  <WhiteSmallText>번역 문의 : 070-8820-3116</WhiteSmallText>
                  <EmailInfo>
                    <a href="mailto:sales@voithru.com">
                      <WhiteSmallText>
                        기업 번역 문의 : sales@voithru.com
                      </WhiteSmallText>
                    </a>
                    <a href="mailto:business@voithru.com">
                      <WhiteSmallText>
                        사업 제휴 문의 : business@voithru.com
                      </WhiteSmallText>
                    </a>
                    <a href="mailto:vendor.hr@voithru.com">
                      <WhiteSmallText>
                        번역가 채용 문의 : vendor.hr@voithru.com
                      </WhiteSmallText>
                    </a>
                  </EmailInfo>
                </ContactInfo>
              </ContactContainer>
            </>
          ) : (
            <>
              <Company>
                <CompanyName>(주) 보이스루</CompanyName>
                <GrayText>
                  서울특별시 강남구 강남대로 374, 10층(역삼동, 케이스퀘어 강남2)
                </GrayText>
                <GrayText>
                  대표자명: 이상헌 | 사업자 등록번호: 342‑88‑01221
                </GrayText>
                <GrayText>고객센터: 02‑6203‑4800</GrayText>
                <Spacer height={10} />
                <a href="https://voithru.com/?mode=policy">
                  <WhiteSmallText>
                    Copyright ⓒ 2025 보이스루 All rights reserved.
                  </WhiteSmallText>
                </a>
              </Company>
              <Spacer height={20} />
              <ServiceContainer>
                <ServiceLinks>
                  <a href="https://voithru.com/translation_localization?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>번역・현지화</WhiteBigText>
                  </a>
                  <a href="https://voithru.com/technology?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>기술</WhiteBigText>
                  </a>
                  <a href="https://voithru.com/content_distribution?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>유통</WhiteBigText>
                  </a>
                </ServiceLinks>
              </ServiceContainer>
              <FamilySites>
                <ServiceLinks>
                  <a href="https://jamake.io/?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>Jamake</WhiteBigText>
                  </a>
                  <a href="https://totus.pro/?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>totus</WhiteBigText>
                  </a>
                  <a href="https://polita.ai/?utm_source=voithru&utm_medium=referral&utm_campaign=&utm_content=footer">
                    <WhiteBigText>Polita</WhiteBigText>
                  </a>
                </ServiceLinks>
              </FamilySites>
              <ContactInfo>
                <WhiteSmallText>문의 가능 시간 : 10시~19시</WhiteSmallText>
                <WhiteSmallText>번역 문의 : 070-8820-3116</WhiteSmallText>
                <EmailInfo>
                  <a href="mailto:sales@voithru.com">
                    <WhiteSmallText>
                      기업 번역 문의 : sales@voithru.com
                    </WhiteSmallText>
                  </a>
                  <a href="mailto:business@voithru.com">
                    <WhiteSmallText>
                      사업 제휴 문의 : business@voithru.com
                    </WhiteSmallText>
                  </a>
                  <a href="mailto:vendor.hr@voithru.com">
                    <WhiteSmallText>
                      번역가 채용 문의 : vendor.hr@voithru.com
                    </WhiteSmallText>
                  </a>
                </EmailInfo>
              </ContactInfo>
            </>
          )}
        </FooterTop>
      </FooterInner>
    </FooterContainer>
  );
};

const Spacer = ({ width, height }: { width?: number; height?: number }) => {
  return <div style={{ width, height }} />;
};

const FooterContainer = styled.footer`
  width: 100%;
  background-color: rgb(38, 38, 38);
  color: #a0a0a0;
  font-size: 14px;
  padding: 50px 0 150px;

  @media (max-width: 768px) {
    padding: 20px 0 100px;
  }
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterTop = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    gap: 40px;
  }
`;

const Company = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CompanyName = styled.p`
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 36px;
  color: rgb(236, 236, 236);
  margin-bottom: 32px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Title = styled.h3`
  font-family: Pretendard, sans-serif;
  color: rgb(137, 138, 141);
  font-size: 14px;
  margin: 1rem 0 32px;
`;

const GrayText = styled.p`
  font-family: Pretendard, sans-serif;
  color: rgb(137, 138, 141);
  font-size: 14px;
`;

const WhiteSmallText = styled.p`
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  color: rgb(255, 255, 255);
`;

const WhiteBigText = styled.p`
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  color: rgb(255, 255, 255);

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const ServiceContainer = styled.div`
  margin-bottom: 20px;
`;

const ServiceLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const FamilySites = styled.div`
  margin-bottom: 20px;
`;

const ContactContainer = styled.div`
  min-width: 250px;
`;

const ContactInfo = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 5px;
`;

const EmailInfo = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-top: 20px;
  line-height: 1.8;
  gap: 5px;
`;

export default Footer;
